import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/tokens.css";
import "./styles/reset.css";
import "./styles/global.css";
import "./styles/app.css";

// Hydration is under way, so the no-JS safety net in index.html isn't needed.
clearTimeout((window as unknown as { __revealFallback?: number }).__revealFallback);

const root = document.getElementById("root")!;
const tree = (
  <StrictMode>
    <App />
  </StrictMode>
);

// Prerendered builds ship real markup inside #root; hydrate it instead of
// throwing it away. Dev and non-prerendered builds fall back to a fresh render.
if (root.hasChildNodes()) {
  hydrateRoot(root, tree);
} else {
  createRoot(root).render(tree);
}
